module.exports = __webpack_public_path__ + "img/Ophiuchus.8a11c2ff.png";